
define('hbars!bizzabo/templates/imagePreview', ['Handlebars'], function (Handlebars) { return Handlebars.compile('<div class="modal-body imagePreviewView">\n\t<a class="close">×</a>\n\t<img src="{{src}}" {{#if width}}width="{{width}}"{{/if}} {{#if height}}height="{{height}}"{{/if}} />\n</div>'); });

